<div class="modal-header">
  <h3 class="modal-title">Publish Report</h3>
  <button class="fa fa-times" [mat-dialog-close]="" style="float: right;cursor: pointer;background: none;border:none"
    aria-hidden="true"></button>
</div>
<div class="modal-body">
  <div class="col-lg-12 mb-4">
    <span class="left inline control-label fw">
      <i class="fa fa-square-o icon-font" (click)="publishReportFilter.isId = true"
        *ngIf="!publishReportFilter.isId"></i>
      <i class="fa fa-check-square icon-font" (click)="publishReportFilter.isId = false"
        *ngIf="publishReportFilter.isId"></i>
      Id
    </span>
    <span class="left inline control-label ml-3 fw">
      <i class="fa fa-square-o icon-font" (click)="publishReportFilter.isDescription = true"
        *ngIf="!publishReportFilter.isDescription"></i>
      <i class="fa fa-check-square icon-font" (click)="publishReportFilter.isDescription = false"
        *ngIf="publishReportFilter.isDescription"></i>
      Description
    </span>
    <span class="left inline control-label ml-3 fw">
      <i class="fa fa-square-o icon-font" (click)="publishReportFilter.isStatus = true"
        *ngIf="!publishReportFilter.isStatus"></i>
      <i class="fa fa-check-square icon-font" (click)="publishReportFilter.isStatus = false"
        *ngIf="publishReportFilter.isStatus"></i>
      Status
    </span>
    <span class="left inline control-label ml-3 fw">
      <i class="fa fa-square-o icon-font" (click)="publishReportFilter.isActionedBy = true"
        *ngIf="!publishReportFilter.isActionedBy"></i>
      <i class="fa fa-check-square icon-font" (click)="publishReportFilter.isActionedBy = false"
        *ngIf="publishReportFilter.isActionedBy"></i>
      Actioned By
    </span>
    <span class="left inline control-label ml-3 fw">
      <i class="fa fa-square-o icon-font" (click)="publishReportFilter.isEffectiveDate = true"
        *ngIf="!publishReportFilter.isEffectiveDate"></i>
      <i class="fa fa-check-square icon-font" (click)="publishReportFilter.isEffectiveDate = false"
        *ngIf="publishReportFilter.isEffectiveDate"></i>
      Effective Date
    </span>
    <span class="left inline control-label ml-3 fw">
      <i class="fa fa-square-o icon-font" (click)="publishReportFilter.isAssessor = true"
        *ngIf="!publishReportFilter.isAssessor"></i>
      <i class="fa fa-check-square icon-font" (click)="publishReportFilter.isAssessor = false"
        *ngIf="publishReportFilter.isAssessor"></i>
      Assessor
    </span>
    <span class="left inline control-label ml-4 fw">
      <i class="fa fa-square-o icon-font" (click)="publishReportFilter.isDateRange = true"
        *ngIf="!publishReportFilter.isDateRange"></i>
      <i class="fa fa-check-square icon-font" (click)="publishReportFilter.isDateRange = false"
        *ngIf="publishReportFilter.isDateRange"></i>
      DateRange
    </span>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <small class="fg-g-red" *ngIf="isTitleErr">Please enter report title</small>
      <small class="fg-g-red" *ngIf="isHeadingErr">Please enter header</small>
      <small class="fg-g-red" *ngIf="isLibraryErr">Please select library</small>
    </div>
    <div class="col-lg-6">
      <div class="form-group">
        <div class="left inline control-label mb-1 fw">Report Title</div>
        <div class="input-group input-group-sm">
          <input type="text" class="form-control form-control-sm" [(ngModel)]="publishReportFilter.title" />
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="form-group">
        <div class="left inline control-label mb-1 fw">Date</div>
        <div class="input-group input-group-sm">
          <input matInput [matDatepicker]="picker" (click)="picker.open()" placeholder="Choose a date"
            class="form-control form-control-sm border-bottom" id="date" placeholder="date"
            [(ngModel)]="publishReportFilter.reportDate" readonly>
          <div class="input-group-append">
            <span class="input-group-text fa fa-calendar" (click)="picker.open()"></span>
          </div>
        </div>
        <mat-datepicker #picker></mat-datepicker>
      </div>
    </div>
    <ng-container *ngFor="let item of publishReportFilter.reportFilter; index as i">
      <ng-container *ngIf="!item.isDeleted">
        <div class="col-lg-6">
          <div class="form-group">
            <div class="left inline control-label mb-1 fw">Header</div>
            <div class="input-group input-group-sm">
              <input type="text" class="form-control form-control-sm" [(ngModel)]="item.header" />
            </div>
          </div>
        </div>
        <div class="col-lg-5">
          <div class="left inline control-label mb-1 fw">Select Library</div>
          <ng-select *ngIf="libraries.length > 0" [items]="libraries" bindLabel="name" appendTo="body" [multiple]="true"
            [(ngModel)]="item.libraries" style="margin-top: -7px;" (change)="onSelectLibrary($event,i)">
          </ng-select>
        </div>
        <div class="col-lg-1">
          <span class="fa fa-plus f-16 mt-4 cursor-pointer" *ngIf="i === publishReportFilter.reportFilter.length -1"
            (click)="addReportFilter()"></span>
          <span class="fa fa-minus f-16 mt-4 ml-1 cursor-pointer" *ngIf="i > 0"
            (click)="removeReportFilter(item)"></span>
        </div>
        <div class="col-lg-5" *ngIf="publishReportFilter.isDateRange">
          <div class="form-group">
            <div _ngcontent-trr-c100="" class="left inline control-label mb-1 fw">Date Range</div>
            <mat-form-field class="example-form-field daterange-custom">
              <mat-date-range-input [formGroup]="datePickerGroup" [rangePicker]="campaignOnePicker">
                <input matStartDate placeholder="Start date" formControlName="start" [(ngModel)]="dateRange.startDate">
                <input matEndDate placeholder="End date" formControlName="end" [(ngModel)]="dateRange.endDate" (dateChange)="onChangeDateRange($event)">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="campaignOnePicker"></mat-datepicker-toggle>
              <mat-date-range-picker #campaignOnePicker></mat-date-range-picker>
            </mat-form-field>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
<div class="modal-footer">
  <button class="btn bg-g-lightGreen btn-sm" (click)="publishReport()">Save</button>
</div>